<!-- 政务菜单管理-->
<template>
  <div>
    <x-menu v-bind="apiParams"></x-menu>
  </div>
</template>

<script>
import { menu } from 'ant-design-vue-admin-x';
export default {
  name: 'govMenu',
  components: {
    XMenu: menu
  },
  data () {
    return {
      apiParams: {
        listsApi: '/menu/govern/list',
        deleteApi: '/menu/govern/',
        addApi: '/menu/govern',
        editApi: '/menu/govern/',
        detailApi: '/menu/govern/',
        authMenuApi: '/menu/govern/treeselect'
      }
    };
  }
};
</script>
